import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  FormControlLabel,
  Checkbox,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
} from "@mui/material";
import { Close } from "@mui/icons-material";

const SignerFieldProperties = ({
  selectedAnnotation,
  onUpdateAnnotation,
  closeButton,
  signers = [],
  showAssignOnly = false,
}) => {
  const [isRequired, setIsRequired] = useState(
    selectedAnnotation?.isRequired || false
  );

  const handleRequiredChange = (event) => {
    const newIsRequired = event.target.checked;
    setIsRequired(newIsRequired);
    onUpdateAnnotation({
      isRequired: newIsRequired,
    });
  };

  const handleSignerChange = (event) => {
    const nextSignerId = event.target.value;
    const signer = (signers || []).find(
      (s) =>
        String(s.signer_id) === String(nextSignerId) ||
        String(s.id) === String(nextSignerId)
    );
    if (!signer) return;
    const signerId = signer.signer_id ?? signer.id;
    const color = signer.color || selectedAnnotation?.signerColor || null;
    onUpdateAnnotation({
      signerId,
      signerColor: color,
      backgroundColor: color,
      borderColor: color,
      signerName: signer.name || null,
    });
  };

  const typeLabelMap = {
    my_text: "Text",
    date: "Date",
    signer_date: "Date",
    signer_text: "Signer Text",
    signer_initials: "Initials",
    signer_initials_text: "Initials",
    signer_chooseImgStamp: "Stamp",
    signer_chooseImgDrivingL: "Driving L...",
    signer_chooseImgPassportPhoto: "Passport Ph..",
    signer_checkmark: "Checkbox",
    signer_dropdown: "Dropdown",
  };
  const annotationLabel =
    typeLabelMap[selectedAnnotation?.type] || selectedAnnotation?.type;

  useEffect(() => {
    setIsRequired(selectedAnnotation?.isRequired || false);
  }, [selectedAnnotation]);

  const rawSignerId =
    selectedAnnotation?.signerId ?? selectedAnnotation?.signer_id ?? "";
  const currentSignerId =
    rawSignerId === "" || rawSignerId == null ? "" : String(rawSignerId);

  const assignControl =
    Array.isArray(signers) && signers.length > 0 ? (
      <FormControl fullWidth size="small" sx={{ mt: showAssignOnly ? 0 : 1.5 }}>
        <InputLabel id="assign-signer-label">Assigned to</InputLabel>
        <Select
          labelId="assign-signer-label"
          label="Assigned to"
          value={currentSignerId}
          onChange={handleSignerChange}
        >
          {signers.map((signer) => {
            const value = String(signer.signer_id ?? signer.id);
            return (
              <MenuItem key={value} value={value}>
                {signer.name || `Signer ${signer.order_id || ""}`}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    ) : null;

  if (showAssignOnly) {
    return (
      <Box
        sx={{
          backgroundColor: "#ffffff",
          width: "100%",
          minWidth: "100px",
          mb: 1.5,
        }}
      >
        {assignControl}
      </Box>
    );
  }

  return (
    <Box
      sx={{
        backgroundColor: "#ffffff",
        width: "100%",
        minWidth: "100px",
        "& .MuiTypography-h6": {
          whiteSpace: "nowrap",
        },
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 2.5,
          mt: 1,
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontWeight: 600,
            fontSize: "16px",
            color: "rgba(0, 0, 0, 0.87)",
            width: "100%",
          }}
        >
          {annotationLabel}
        </Typography>

        <Close
          style={{
            cursor: "pointer",
            color: "rgba(0, 0, 0, 0.54)",
            fontSize: "20px",
          }}
          onClick={closeButton}
        />
      </Box>

      {assignControl}

      <Box
        sx={{
          mt: 2.5,
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <FormControlLabel
          sx={{
            margin: 0,
            "& .MuiFormControlLabel-label": {
              margin: 0,
            },
          }}
          control={
            <Checkbox
              checked={isRequired}
              onChange={handleRequiredChange}
              size="small"
              sx={{
                color: "rgba(0, 0, 0, 0.54)",
                "&.Mui-checked": {
                  color: "rgb(0, 145, 255)",
                },
                padding: "4px",
              }}
            />
          }
          label={
            <Typography
              variant="body2"
              sx={{
                fontSize: "13px",
                color: "rgba(0, 0, 0, 0.7)",
                ml: 0.5,
              }}
            >
              Required
            </Typography>
          }
        />
      </Box>
    </Box>
  );
};

export default SignerFieldProperties;
